/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type PatientAlertTypes = typeof PatientAlertTypes[keyof typeof PatientAlertTypes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientAlertTypes = {
  TempoDayTwoIncomplete: 'TempoDayTwoIncomplete',
  TempoDayOneIncomplete: 'TempoDayOneIncomplete',
  InsuranceNotSet: 'InsuranceNotSet',
  NoPrimaryInsuranceSet: 'NoPrimaryInsuranceSet',
  MultipleInsuranceWithNoSecondarySet: 'MultipleInsuranceWithNoSecondarySet',
  CCMConsentPending: 'CCMConsentPending',
  OptedOutOfCCM: 'OptedOutOfCCM',
  FollowUpScheduleSuggested: 'FollowUpScheduleSuggested',
  RTMNeedsReview: 'RTMNeedsReview',
  PatientAgreementPending: 'PatientAgreementPending',
  FormPending: 'FormPending',
  TelehealthMeetingCreationFailed: 'TelehealthMeetingCreationFailed',
  EligibilityCheckFailed: 'EligibilityCheckFailed',
  EligibilityCoverageInactive: 'EligibilityCoverageInactive',
  EligibilityActionRequired: 'EligibilityActionRequired',
  EligibilityCoverageNotFound: 'EligibilityCoverageNotFound',
  NoValidCommunicationMethod: 'NoValidCommunicationMethod',
} as const;
